import { Form as UIForm } from "@/components/ui/form";
import { cn } from "@/lib/utils";
import { PropsWithChildren } from "react";
import { FieldValues, UseFormReturn, FieldErrors } from "react-hook-form";

interface FormProps<T extends FieldValues> extends PropsWithChildren {
  form: UseFormReturn<T>;
  handleSubmit: (data: T) => void;
  onValidationError?: (errors: FieldErrors<T>) => void;
  className?: string;
}

export default function Form<T extends FieldValues>({
  form,
  children,
  handleSubmit,
  onValidationError,
  className,
}: FormProps<T>) {
  return (
    <UIForm {...form}>
      <form
        onSubmit={form.handleSubmit(handleSubmit, onValidationError)}
        className={cn("flex flex-col gap-3 min-h-0", className)}
      >
        {children}
      </form>
    </UIForm>
  );
}
